import { Component, OnInit } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DataService } from '../../../data.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {

  currentUrl: string;
  location: string;
  Id: any;

  username: any;
  fullname: any;
  email: any;
  log: any;
  sign: any;
  country: any;
  profileId: any;
  phone: any;
  acc: any;

  form = 0;
  address: any;

  ripple: any;
  usdtbep: any;
  usdttrc: any;
  eth: any;
  btc: any;
  upi: any;
  upname: any;

  bankname: any;
  bankacc: any;
  banknum: any;
  bankifsc: any;

  cpass: string;
  newpass: string;

  support = '+14845426589';
  message: string;

  lastwith: any;
  totwith: any;
  totdep: any;
  totprof: any;
  pwith: any;
  lastdep: any;
  monthpro: any;
  totref: any;

  constructor(
    private server: DataService,
    public toastr: ToastrManager,
    public session: SessionStorageService,
    private route: Router,
    private activate: ActivatedRoute
  ) {
    route.events.subscribe((_: NavigationEnd) => (this.currentUrl = _.url));
    this.location = window.location.origin;
    this.Id = this.session.get('sessionID');
  }

  ngOnInit() {


    let data = this.activate.snapshot.data;
    let user = data['news'].dep['message']?.[0];

    console.log('Resolver data:', data);



    this.acc = user?.mainaccountbal;
    this.username = user?.username;
    this.profileId = user?.profileId;
    this.fullname = user?.fullname;
    this.email = user?.email;
    this.log = user?.last_login;
    this.country = user?.country;
    this.sign = user?.date_created;
    this.phone = user?.phone;

    this.lastwith = data['news'].dep['lastwith'] || 0;
    this.totwith = data['news'].dep['totwith'] || 0;
    this.totdep = data['news'].dep['totdep'] || 0;
    this.totprof = data['news'].dep['totpro'] || 0;
    this.lastdep = data['news'].dep['lastdep'] || 0;
    this.monthpro = data['news'].dep['monthpro'] || 0;
    this.pwith = data['news'].dep['pwith'] || 0;
    this.totref = data['news'].ref['refSum'] || 0;


    this.ripple = user?.ripple || '';
    this.usdtbep = user?.usdtbepaddress || '';
    this.usdttrc = user?.usdttrcaddress || '';
    this.eth = user?.ethaddress || '';
    this.btc = user?.btcaddress || '';
    this.upi = user?.upiaddress || '';
    this.upname = user?.upname || '';

    this.message = `Hello Support, my username is ${this.username}`;
  }

  get whatsappLink() {
    return `https://wa.me/${this.support}?text=${encodeURIComponent(this.message)}`;
  }


  get depositGrams() {
  return Number(String(this.totdep).replace(/,/g, '')) / 130;
}

  openForm(type: string) {
    this.form = 1;
    this.address = type;
  }

  cancel() {
    this.form = 0;
    this.address = null;
  }

  update() {

    if (!this.cpass) {
      return this.toastr.warningToastr('Enter your current password');
    }

    let bank = '';

    if (this.bankname && this.bankacc && this.banknum && this.bankifsc) {
      bank = `${this.bankname}-${this.bankacc}-${this.banknum}-${this.bankifsc}`;
    }

    let payload = {
      ripple: this.ripple,
      usdtbepaddress: this.usdtbep,
      usdttrcaddress: this.usdttrc,
      ethaddress: this.eth,
      btcaddress: this.btc,
      upiaddress: this.upi,
      upname: this.upname,
      bank: bank,
      password: this.cpass,
      newpass: this.newpass,
      Id: this.Id,
      key: 'proUp',
    };

    this.server.Api(payload).subscribe((res: any) => {

      if (res.code == 1) {
        this.toastr.successToastr('Profile updated successfully');
        this.cancel();
        this.route.navigate(['/dashboard']);
      }

      if (res.code == 2) {
        this.toastr.warningToastr('Incorrect password');
      }

    });
  }

  async copy() {
    const text = `${this.location}/signup?ref=${this.profileId}`;
    await navigator.clipboard.writeText(text);
    this.toastr.successToastr('Link copied');
  }

  logOut() {
    this.server.logOut();
  }
}
